import {combineReducers} from 'redux'
import { reducer as reduxFormReducer } from 'redux-form';
import success from './formReducer';
import config from './configReducer';

import ajaxCallInProgress from './ajaxStatusReducer';
const rootReducers = combineReducers({
    ajaxCallInProgress,
    success,
    config,
    form: reduxFormReducer, // mounted under "form"

});

export default rootReducers


// WEBPACK FOOTER //
// ./src/reducers/index.js